module.exports = __webpack_public_path__ + "static/media/dot_blue.85cf7d90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/dot_blue.svg
// module id = ./src/assets/media/forum/dot_blue.svg
// module chunks = 16